import { render, staticRenderFns } from "./ResendVerification.vue?vue&type=template&id=1205a60b&scoped=true"
import script from "./ResendVerification.vue?vue&type=script&lang=js"
export * from "./ResendVerification.vue?vue&type=script&lang=js"
import style0 from "./ResendVerification.vue?vue&type=style&index=0&id=1205a60b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1205a60b",
  null
  
)

export default component.exports